
import Vue from 'vue';
import Token from '../Token';

import { Padder, Spacer as QSpacer } from '../Spacings';
import { Row, Column } from '../Grid';
import WebText from '../Text/Text.vue';
import QButton from '../Button/Button.vue';
import Card from '../Card/Card.vue';

import uploadIcon from '../../Icons/UploadIconShape.vue';
import PhotoCamera from '../../Icons/PhotoCamera.vue';
import refreshFile from '../../Icons/RefreshFile.vue';
import cancelFile from '../../Icons/CancelFile.vue';
/**
 * Single Uploader Component
 *
 * Upload with text and detail with placeholder.
 */
export default Vue.extend<any, any, any, any>({
  name: 'SingleUploader',
  components: {
    Padder,
    QSpacer,
    WebText,
    QButton,
    Row,
    Column,
    Card,
    uploadIcon,
    PhotoCamera,
    refreshFile,
    cancelFile
  },
  props: {
    /**
     * Ref key of Document Type.<br />
     * Included in file name.
     */
    documentType: {
      type: String,
      default: ''
    },
    /**
     * Label text after upload icon.
     */
    UploadLabel: {
      type: String,
      default: ''
    },
    /**
     * **not available**
     */
    documentOwner: {
      type: String,
      default: ''
    },
    /**
     * Placeholder of preview image.
     */
    defaultBackground: {
      type: String,
      default: ''
    },
    /**
     * Shadow of the uploader.<br />
     * Possible value: `flat` | `container` | `interactive` | `float` | `hover`<br />
     * From left to right, shadow will be bigger.
     */
    elevation: {
      type: String,
      default: 'float'
    },
    /**
     * Preview image of uploader.<br />
     * Possible value: background-size css property.
     */
    backgroundSize: {
      type: String,
      default: 'contain'
    },
    /**
     * The title of the uploader.
     */
    titleContent: {
      type: String,
      default: ''
    },
    /**
     * The description of the uploader.
     */
    subtitleContent: {
      type: String,
      default: ''
    },
    /**
     * Make title shown to the uploader.
     */
    titleShow: {
      type: Boolean,
      default: true
    },
    /**
     * Make description shown to the uploader.
     */
    subtitleShow: {
      type: Boolean,
      default: true
    },
    /**
     * Disable the upload file.
     */
    hideUpload: {
      type: Boolean,
      default: false
    },
    /**
     * Make result of the preview image not resized.
     */
    noResize: {
      type: Boolean,
      default: false
    },
    /**
     * Using image content if not resized.
     */
    imgcontent: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      upload: '',
      documentObj: {},
      imagecontent: ''
    };
  },
  created() {
    this.imagecontent = this.imgcontent;
  },
  methods: {
    computedBackground(value: string) {
      if (!value) {
        return `background-image: url(${this.defaultBackground}); background-size: ${this.backgroundSize}`;
      }
      return `background-image: url(${value}); background-size: ${this.backgroundSize}`;
    },
    computedShow(whichContent: string) {
      if (whichContent) {
        return `visibility: visible`;
      }
      return `visibility: hidden`;
    },
    chooseFilesDocument(key: string) {
      this.upload = key;
      if (this.$refs[`fileUploadDocument_${key}`]) {
        // @ts-ignore
        this.$refs[`fileUploadDocument_${key}`].click();
      }
      this.$forceUpdate();
    },
    previewImageDocument(event: Event, key: string) {
      // @ts-ignore
      const input = event.target;
      // @ts-ignore
      if (input.files && input.files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          // @ts-ignore
          this.documentObj = {
            name: this.documentType + '-' + name + '.' + fileType,
            previewImage: img.src,
            content: !this.noResize ? this.resizeMe(img) : this.imagecontent
          };
          /**
           * Handle when user change the file
           * @event input
           * @type {function}
           */
          this.$emit('input', this.documentObj);
          this.$forceUpdate();
        };

        // @ts-ignore
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        img.onload = () => {
          const options = {
            maxWidth: 800,
            maxHeight: 800,
            quality: 0.7,
            // @ts-ignore
            success(result) {
              reader.readAsDataURL(result);
            },
            // @ts-ignore
            error(e) {
              console.error(e.message);
            }
          };
          // @ts-ignore
          reader.readAsDataURL(input.files[0]);
        };
        // @ts-ignore
        img.src = _URL.createObjectURL(input.files[0]);
        // @ts-ignore
        const fileType = input.files[0].type.replace('image/', '');
        const name = this.documentOwner.split(' ').join('_');

        // @ts-ignore
      }
    },
    // @ts-ignore
    resizeMe(img) {
      let canvas = document.createElement('canvas');

      let max_width = 800;
      let max_height = 800;

      let width = img.width;
      let height = img.height;

      // calculate the width and height, constraining the proportions
      if (width > height) {
        if (width > max_width) {
          //height *= max_width / width;
          height = Math.round((height *= max_width / width));
          width = max_width;
        }
      } else {
        if (height > max_height) {
          //width *= max_height / height;
          width = Math.round((width *= max_height / height));
          height = max_height;
        }
      }

      // resize the canvas and draw the image data into it
      canvas.width = width;
      canvas.height = height;
      let ctx = canvas.getContext('2d');
      // @ts-ignore
      ctx.drawImage(img, 0, 0, width, height);
      // @ts-ignore
      return canvas.toDataURL('image/jpeg', 0.7).split('base64,')[1]; // get the data from canvas as 70% JPG (can be also PNG, etc.)
    }
  }
});
